<template>
  <div class="footer">
    <p>版权所有© 上海俊城达网络科技集团有限公&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;辽ICP备19016869号-1</p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
.footer {
  height: 115px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}
.footer p {
  font-size: 16px;
  color: #A6B0BD;
  
}
</style>
